import React from 'react';
import Lottie from 'lottie-react';
import { Button } from 'react-bootstrap';
import Animation from '../../animations/AnimationError.json';

const ConnectionError = ({ refreshBtn = false, message = 'Algo salió mal. Por favor, recarga la página o intenta nuevamente en unos momentos.' }) => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center p-4 w-100 m-auto mb-5 bg-infox"
      style={{ minHeight: '60vh', maxWidth: '700px' }}
    >
      <Lottie animationData={Animation} className="w-40" />
      <h3 className="text-center my-5">{message}</h3>
      {refreshBtn && (
        <Button className="btn btn-primary" onClick={() => window.location.reload()}>
          Recargar página
        </Button>
      )}
    </div>
  );
};

export default ConnectionError;
